import { Route, Switch } from 'react-router-dom'

import MembersView from './MembersView'
import React from 'react'

const MembersApp = () => {
  return (
    <Switch>
      <Route path='/soccer/members'>
        <MembersView />
      </Route>
    </Switch>
  )
}

export default MembersApp
